function EventFieldAttributes({ type, attributes = {}, updateAttributes }) {
	switch (type) {
		case "short_text":
			return (
				<>
					<label style={{ display: "flex", flexDirection: "column" }}>
						<span>placeholder (플레이스 홀더)</span>
						<input
							type="text"
							value={attributes.placeholder || ""}
							placeholder="예: 이름을 입력해 주세요"
							onChange={(e) => updateAttributes("placeholder", e.target.value)}
						/>
					</label>
				</>
			);

		case "long_text":
			return (
				<>
					<label style={{ display: "flex", flexDirection: "column" }}>
						<span>placeholder (플레이스 홀더)</span>
						<input
							type="text"
							value={attributes.placeholder || ""}
							placeholder="예: 이름을 입력해 주세요"
							onChange={(e) => updateAttributes("placeholder", e.target.value)}
						/>
					</label>
				</>
			);

		case "number":
			return (
				<>
					<label style={{ display: "flex", flexDirection: "column" }}>
						<span>min (최소값)</span>
						<input type="text" value={attributes.min || ""} onChange={(e) => updateAttributes("min", e.target.value)} />
					</label>
					<label style={{ display: "flex", flexDirection: "column" }}>
						<span>max (최대값)</span>
						<input type="text" value={attributes.max || ""} onChange={(e) => updateAttributes("max", e.target.value)} />
					</label>
				</>
			);

		case "select":
			return <></>;

		case "multi_select":
			return <></>;

		case "checkbox":
			return <></>;

		case "radio":
			return <></>;

		case "date":
			return <></>;

		case "file":
			return <></>;

		case "custom":
			return <></>;

		default:
			return null;
	}
}

export default EventFieldAttributes;
